import { createStyles } from "@material-ui/styles";
const styles = ({ breakpoints }) =>
  createStyles({
    root: {
      [`@media (max-width:${breakpoints.values.md}px)`]: {
        padding: '42px 0'
      },
    },
    mpHeader: {
      fontStyle: "normal",
      fontWeight: "600",
      fontSize: "50px",
      lineHeight: "60px",
      color: "#153862",
      padding: "0 18px",
      marginBottom: "74px",
    },
    featureListContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: "40px",
      [`@media (max-width:${breakpoints.values.sm}px)`]: {
        gap: "28px",
      },
    },
    featureList: {
      display: "flex",
      gap: "25px",
      [`@media (max-width:${breakpoints.values.sm}px)`]: {
        gap: "10px",
      },
    },
    iconImage: {
      "& img": {
        width: "85px",
        [`@media (max-width:${breakpoints.values.sm}px)`]: {
          width: "53px",
        },
      },
    },
    article: {
      "& > div": {
        fontSize: "26px",
        fontWeight: 600
      },
      "& > p": {
        fontSize: "16px",
      },
      [`@media (max-width:${breakpoints.values.sm}px)`]: {
        "& > div": {
          fontSize: "18px",
        },
        "& > p": {
          fontSize: "12px",
        },
      },
    },
  });

export default styles;



// WEBPACK FOOTER //
// ./src/components/StartContainer/MemberProgram.style.js